import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image',
  imports: [],
  templateUrl: './image.html',
  styleUrl: './image.css',
})
export class Image {
  img: string = '';
  @Input('img')
  set changeImage(newImage: string) {
    this.img = newImage;
  }
  @Input() alt!: string;

  loaded = false;
  imageDefault = '/images/default.jpeg';

  imgLoaded() {
    this.loaded = true;
  }

  imgError() {
    console.log('Error loading image:', this.img);
    this.img = this.imageDefault;
  }
}
